import keys from '@debbie/common/dist/cache/keys.js';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { casesEntity, useCase } from '@debbie/cortex/dist/cases/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import noData from '../../../assets/images/no-data.svg';
import THEME from '../../../theme.js';
import CaseVouchers from '../../economy/case-vouchers/CaseVouchers.js';
import CreateVoucher from '../../economy/CreateVoucher/index.js';
import { Button, ButtonDrop, Panel } from '../../index.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
// Creditors register their own claim and payments they received; caseworkers get every category
const creditorWebCategories = [
    VoucherCategory.PRINCIPAL,
    VoucherCategory.INTEREST,
    VoucherCategory.COST,
    VoucherCategory.TRANSACTION,
];
const Economy = (props) => {
    const [addVoucherOpen, setAddVoucherOpen] = useState(false);
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    let voucherCount = 0;
    if (_caseVouchers) {
        voucherCount = _caseVouchers.length;
    }
    const decoratedCaseVouchers = _caseVouchers &&
        _caseVouchers.map((caseVoucher) => {
            return { ...caseVoucher, children: [] };
        });
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, null, lang.cases.newCaseEconomyExplainer),
        React.createElement(Panel, { header: React.createElement(Header, null,
                React.createElement("div", null, lang.economy.caseEconomy),
                React.createElement(HeaderRight, null,
                    React.createElement(ButtonDrop, { open: addVoucherOpen, onOpen: () => setAddVoucherOpen(true), onClose: () => setAddVoucherOpen(false), size: "mini" }, singleCase && (React.createElement(CreateVoucher, { caseId: singleCase.caseId, creditorId: singleCase.creditorId, onCreate: () => setAddVoucherOpen(false), voucherTypeFilter: [VoucherTypeIds.PRINCIPAL], categoryFilter: site === Site.Client ? creditorWebCategories : undefined, defaultImposedByCreditor: {
                            [VoucherTypeIds.COLLECTIONFEE]: true,
                            [VoucherTypeIds.REMINDERFEE]: true,
                        }, caseVouchers: decoratedCaseVouchers || [], singleCase: singleCase }))))) },
            singleCase && decoratedCaseVouchers ? (React.createElement(CaseVouchers, { caseVouchers: decoratedCaseVouchers, singleCase: singleCase })) : (React.createElement(PlaceholderLoader, null)),
            singleCase && voucherCount === 0 && (React.createElement(NoDataWrapper, null,
                React.createElement(NoDataImage, { src: noData }),
                React.createElement("h2", null, lang.cases.noDebts),
                React.createElement("p", null, lang.cases.noDebtsExplainer)))),
        React.createElement("div", null,
            React.createElement(Button, { disabled: !(singleCase && voucherCount), onClick: () => {
                    q.invalidate(keys.write.modify(casesEntity, props.caseId));
                    c.redirect.redirect(`/cases/${props.caseId}`);
                } }, lang.creditors.next),
            React.createElement("p", { onClick: () => {
                    q.invalidate(keys.write.modify(casesEntity, props.caseId));
                    c.redirect.redirect(`/cases/${props.caseId}`);
                }, style: {
                    display: 'inline-block',
                    cursor: 'pointer',
                    marginLeft: '1em',
                    color: THEME.COLOR_GREY,
                } }, lang.misc.skip))));
};
export default Economy;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const HeaderRight = styled.div `
  display: flex;
  align-items: center;
`;
const NoDataImage = styled.img `
  width: 90%;
  max-width: 200px;
  margin-bottom: 2em;
`;
const NoDataWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;

  h2,
  p {
    margin: 0;
    margin-bottom: 1em;
  }
`;
//# sourceMappingURL=Economy.js.map